import {
  required,
  confirmed,
  length,
  email,
  max,
  max_value,
  min,
  min_value,
  numeric,
  regex,
  alpha_num,
  alpha_spaces,
  integer,
  oneOf,
  percent,
  max_percent
} from "vee-validate/dist/rules";
import {
  extend,
  configure
} from "vee-validate";
import i18n from "./i18n";

if (localStorage.Lang != null)
  i18n.locale = localStorage.Lang;

extend('requiredServicer', {
  validate(value) {
    return value && value.id !== null && value.id !== undefined;
  },
  message: i18n.t("FieldRequired")
});

extend("required", {
  ...required,
  message: i18n.t("FieldRequired")
});

extend("email", {
  ...email,
  message: i18n.t("ValidEmail")
});

extend("url", {
  ...regex,
  message: i18n.t("ValidUrl")
})

extend("confirmed", {
  ...confirmed,
  message: i18n.t("ConfirmationNoMatch")
});

extend("uniqueEmail", {
  params: ['hasError'],
  validate(email, { hasError }) {
    return !hasError || hasError == 'false';
  },
  message: i18n.t("UniqueEmail")
});

extend("duplicateEmail", {
  params: ['hasError'],
  validate(email, { hasError }) {
    return !hasError || hasError == 'false';
  },
  message: i18n.t("DuplicateEmail")
});

// TODO if we update vee-validate to3.2 we can use @ notation to grab value of another field
// if we do that, we can probably interpolate the message and rename to make this rule more flexible
// https://logaretm.github.io/vee-validate/advanced/cross-field-validation.html#targeting-other-fields
extend("renewal_date_after", {
  params: ['effective'],
  validate(renewal, { effective }) {
    return new Date(renewal) > new Date(effective);
  },
  message: i18n.t("InvalidRenewalDate")
});
extend("expiration_date_after", {
  params: ['effective'],
  validate(expiration, { effective }) {
    return new Date(expiration) > new Date(effective);
  },
  message: i18n.t("InvalidExpirationDate")
});
extend("cancel_date_range", {
  params: ['effective', 'renewal'],
  validate(cancel, { effective, renewal }) {
    const cancelDate = new Date(cancel);
    const effectiveDate = new Date(effective);
    const renewalDate = new Date(renewal);
    return effectiveDate <= cancelDate && cancelDate < renewalDate;
  },
  message: (fieldName, placeholder) => {
    const cancelDate = new Date(placeholder._value_);
    const beforeEffectiveDate = cancelDate < new Date(placeholder.effective);
    const afterRenewalDate = new Date(placeholder.renewal) <= cancelDate;
    if (beforeEffectiveDate && afterRenewalDate)
      return i18n.t("InvalidCancellationDate");
    else if (beforeEffectiveDate)
      return i18n.t("InvalidCancellationDateBeforeEffectiveDate");
    else if (afterRenewalDate)
      return i18n.t("InvalidCancellationDateAfterRenewalDate");
    return "";
  },
});
// TODO refactor two postal code errors to display selected country
extend("lengthZip", {
  ...length,
  message: i18n.t("InvalidFormat"),
});

extend("max", {
  ...max,
  message: i18n.t("TooManyCharacters")
});

extend("max_value", {
  ...max_value,
  message: i18n.t("ValueTooHigh")
});

extend("min", {
  ...min,
  message: i18n.t("TooFewCharacters")
});

extend("min_value", {
  ...min_value,
  message: i18n.t("ValueTooLow")
});

extend("numeric", {
  ...numeric,
  message: i18n.t("MustBeNumber")
});

extend("regex", {
  ...regex,
  message: i18n.t("IncorrectFormat")
});

extend("regexZip", {
  ...regex,
  message: i18n.t("InvalidFormat"),
});

extend("alpha_spaces", {
  ...alpha_spaces,
  message: i18n.t("CharactersAndSpaces"),
});

extend("alpha_spaces_extended", {
  validate(value) {
    const regex = /^[a-zA-Z\s'-.]+$/;
    return regex.test(value);
  },
  message: i18n.t("CharactersSpacesHyphenApostropheDot"), // Update the message key
});

extend("integer", {
  ...integer,
  message: i18n.t("WholeNumber"),
});

extend('epic_primary_contact', {
  validate(value) {
    return value;
  },
  message: i18n.t("APrimaryContactRequired")
});

extend('epic_sic_code', {
  params: ['sicCodes'],
  validate(value, { sicCodes }) {
    //var isValidCode = sicCodes.includes(value);
    //var regex = new RegExp("^[0-9]{2,8}$");
    //return regex.test(value) && isValidCode;
    return sicCodes.includes(value);
  },
  message: i18n.t("InvalidSICCode")
});

extend('epic_naics_code', {
  params: ['naicsCodes'],
  validate(value, { naicsCodes }) {
    //var isValidCode = naicsCodes.includes(value);
    //var regex = new RegExp("^[0-9]{6}$");
    //return regex.test(value) && isValidCode;
    return naicsCodes.includes(value);
  },
  message: i18n.t("InvalidNAICSCode")
});

extend('bp_sic_code', {
  validate(value) {
    var regex = new RegExp("^[0-9]{4}$");
    return regex.test(value);
  },
  message: i18n.t("SICCodeDigits")
});
// TODO: Determine actual regex for NAICS code
extend('naics_code', {
  validate(value) {
    var regex = new RegExp("^[0-9]{6}$");
    return regex.test(value);
  },
  message: i18n.t("NAICSCodeDigits")
});

extend('tax_id', {
  validate(value) {
    var regex = new RegExp("^[0-9]{2}-[0-9]{7}$");
    return regex.test(value);
  },
  message: i18n.t("InvalidTaxPayerID")
});

extend('number_2_decimals', {
  validate(value) {
    var regex = new RegExp('^[0-9]+(\.[0-9]{1,2})?$'); //for plain number without masked string
    return regex.test(value);
  },
  message: i18n.t("IncorrectCurrency") //need to improve this TBD how we apply mask
});

extend('policy_number', {
  validate(value) {
    var regex = /^[a-zA-Z0-9\s.\)\(\/\\-]+$/g;
    return regex.test(value);
  },
  message: i18n.t("InvalidCharacters")
});

extend('areacode', {
  validate(value) {
    //value contains the mask so is (xxx) yyy-zzzz format.
    //this only gets called if the min 14 chars validation passes as it's lower in the priority
    //but I'm adding the length check just in case someone reorders the validation method list
    if(value.length >= 2){
      if(value.charAt(1) === "0" || value.charAt(1) === "1") {
        return false;
      }
    }
    return true;
  },
  message: i18n.t("InvalidAreaCode")
});

extend('phoneprefix', {
  validate(value) {
    //value contains the mask so is (xxx) yyy-zzzz format.
    //this only gets called if the min 14 chars validation passes as it's lower in the priority
    //but I'm adding the length check just in case someone reorders the validation method list
    if(value.length >= 7){
      if(value.charAt(6) === "0" || value.charAt(6) === "1") {
        return false;
      }
    }
    return true;
  },
  message: i18n.t("InvalidPhonePrefix")
});

// extend('no_white', {
//   validate(value) {
//     return value.trim().length > 0;
//   },
//   message: 'White space is invalid'
// });

extend("one_of", oneOf);

extend("four_digit_year", {
  validate(inputDate) {
    return new Date(inputDate) > new Date('1000');
  },
  message: i18n.t("FourDigitYear")
});

extend("new_business_until", {
  validate(value) {
    var regex = new RegExp('^(0[1-9]|10|11|12)/20[0-9]{2}$'); //for plain number without masked string
    return regex.test(value);
  },
  message: i18n.t("DateFormatValidation")
});

extend("uom_mismatch", {
  validate(value) {
    return false;
  },
  message: i18n.t("ValidUnit")
});

extend("dob_date", {
  validate(value) {
    if(!(value instanceof Object)){
      value = new Date(value);
    }
    return value <= new Date();
  },
  message: i18n.t("InvalidDOBDate")
});

extend("percent", {
  validate(value) {
    // Calculated values are numbers; only user-entered text is localized.
    if (i18n.locale == "fr" && typeof value === "string") {
      var regex = /^[0-9]*(,[0-9]{0,4})?%?$/;
      return regex.test(value);
    }
    else {
      var regex = /^[0-9]*(\.[0-9]{0,4})?%?$/;
      return regex.test(value);
    }
  },
  message: i18n.t("InvalidPercentage")
});

extend("max_percent", {
  validate(value) {
    var percent = String(value).replace('%', '');
    if (i18n.locale == "fr") {
      percent = percent.replace(',', '.');
    }
    if (!isNaN(parseFloat(percent)))
      return parseFloat(percent) <= 100;
    else return false;
  },
  message: i18n.t("ValueTooHigh")
});

configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid',
  }
});

extend('commissionable', {
  params: ['commissionable'],
  validate(value) {
    return value.isCommissionable;
  },
  message: i18n.t("NotCommissionableProducer")
});


//This one is used by search lookups that are required but have numeric selections.  The backend passes 0 on
//required integer fields but since 0 isn't a valid selection for a lookup, the field looks empty so using the
//min_value check would give a message that doesn't make sense.
extend('nonzerointrequired', {
  validate(value) {
    return value !== null && value !== undefined && value > 0;
  },
  message: i18n.t("FieldRequired")
});

